import AccessLogs from "./AccessLogs";
import { browserAndOsDetails } from "./BrowserAndOsDetails";

export const userAccessDetails = (accessed_item) => {
  const frmData = new FormData();
  frmData.append("user_id", localStorage.getItem("username"));
  frmData.append("accessed_item", accessed_item);
  frmData.append("browser_type", browserAndOsDetails()[0]);
  frmData.append("os_type", browserAndOsDetails()[1]);
  AccessLogs(frmData);
};
